import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
// import { TimerComponent } from '../../../../shared/components/timer/timer.component';
import { CommonModule, AsyncPipe } from '@angular/common';
import { CardComponent } from '../card/card.component';
import { mapHorseAuctionsToCardFormat } from 'src/app/_utlis/auction-data-mapper';
import { BuyerAuctionCardComponent } from 'src/app/app-modules/buyer/buyer-shared/components/buyer-auction-card/buyer-auction-card.component';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AuctionItemCardComponent } from '../../../buyer/buyer-shared/components/auction-item-card/auction-item-card.component';
import { AuctionService } from 'src/app/app-modules/buyer/buyer-modules/buyer-auctions/_services/auction/auction.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import {
  isWinner,
  isSold,
  isUnSold,
  isRna,
} from 'src/app/_utlis/status-helper';
import { NoDataComponent } from '../../../../Shared/components/no-data/no-data.component';
import { JqueryInitService } from 'src/app/Core/_services/jquery/jquery-init.service';

export interface HorseAuction {
  id: number;
  image: string;
  title: string;
  auctionEndDate: string;
  sire: string;
  dam: string;
  birthDate: string;
  currentBid: number;
  hipNumber: string;
  seller: {
    name: string;
    image: string;
  };
  detailsLink: string;
}

@Component({
    selector: 'app-live-horses',
        standalone: true,
imports: [
        CommonModule,
        AuctionItemCardComponent,
        SkeletonLoaderComponent,
        NoDataComponent,
        TranslatePipe,
        AsyncPipe,
    ],
    templateUrl: './live-horses.component.html',
    styleUrl: './live-horses.component.scss'
})
export class LiveHorsesComponent {
  @Input() data: any;
  @Input() currentDateTime: any;
  @Input() locale: any;
  @Input() isLoading: boolean = false;
  @Input() has_upcoming_auctions: boolean = false;
  @Input() loggedIn: boolean = false;
  @Input() user_id: any;
  @Input() dir: any;
  @Input() displayType!: string;
  @Output() loadData: EventEmitter<any> = new EventEmitter<any>();
  sectionTitle: string = 'Live Horses';
  sectionDescription: string =
    'Explore our curated selection of distinguished thoroughbreds available for immediate bidding.';
  viewAllLink: string = '/auction-grid';
  auctionItems: HorseAuction[] = [];
  cardAuctions: any[] = [];
  constructor(
    private router: Router,
    private auctionService: AuctionService,
    private toastService: ToastService,
    private buyerService: BuyerService,
    private initJQuery: JqueryInitService,
    public localeService: LocaleService,
    private translate: TranslateService
  ) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && changes['data'].currentValue) {
      if (Array.isArray(this.data)) {
        setTimeout(() => {
          this.cardAuctions = this.data.map((rawData: any) =>
            this.mapAuctionData(rawData)
          );
        }, 0); // Allow the view to update before processing data
      }
    }
  }
  mapAuctionData(rawData: any): any {
    // Extract the main auction data and horse data

    const running = rawData?.auction_settings?.running;
    const ended = rawData?.auction_settings?.ended;
    let auctionType = this.displayType || 'active';
    if (typeof running === 'boolean' && typeof ended === 'boolean') {
      if (running && !ended) {
        auctionType = 'active';
      } else if (!running && ended) {
        auctionType = 'previous';
      } else if (!running && !ended) {
        auctionType = 'upcoming';
      }
    }

    const mappedAuction = {
      auction: {
        ...rawData?.auction,
        buyer_status: rawData?.buyer_status,
        seller_email: rawData?.seller_email || rawData?.auction?.seller?.user?.email || rawData?.ownerUser?.email || '',
      },
      auction_settings: rawData?.auction_settings,
      auc_id: rawData?.auction?.id,
      id: rawData?.id,
      name: rawData?.name,
      hip: rawData?.hip_number,
      bornData: rawData?.horse?.date_of_birth,
      Sire: rawData?.horse?.sire,
      Dam: rawData?.horse?.dam,
      'Sire of Dam': rawData?.horse?.sire_of_dam,
      image: rawData?.auction_pictures?.[0]?.url || '',
      Sex: rawData?.horse?.sex,
      consignor: rawData?.created_by_user_name,
      Category: rawData?.horse?.category,
      winner_user_id: rawData?.winner_user_id,
      can_bid: rawData?.auction_item_settings?.can_bid,
      in_user_wishlist: rawData?.auction_item_settings?.in_user_wishlist,
      is_this_user_winner: rawData?.auction_item_settings?.is_this_user_winner,
      wishlistClicked: false,
      highest_bid_amount: rawData?.highest_bid?.amount || null,
      display_price: rawData?.display_price ?? null,
      min_bid: rawData?.min_bid,
      current: this.currentDateTime,
      slug: rawData?.slug,
      aucSlug: rawData?.auction?.slug,
      buyer_document_categories: rawData?.buyer_document_categories,
      rna_status_offers:
        (isRna(rawData?.status) && auctionType !== 'previous') ||
        (isRna(rawData?.status) &&
          auctionType == 'previous' &&
          !rawData?.make_an_offer?.is_available &&
          rawData?.make_an_offer.time_window_days == 0),
      rna_status: isRna(rawData?.status),
      reserve_price: rawData?.reserve_price,
      winnerUser: isWinner(rawData?.status),

      soldUser:
        (isSold(rawData?.status) ||
          rawData?.make_an_offer?.item_has_accepted_offer) &&
        rawData?.unsold_flag_at == null,
      unSold: isUnSold(rawData?.status),
      unSold_offers:
        (isUnSold(rawData?.status) && auctionType !== 'previous') ||
        (isUnSold(rawData?.status) &&
          auctionType == 'previous' &&
          !rawData?.make_an_offer?.is_available &&
          rawData?.make_an_offer.time_window_days == 0 &&
          !isRna(rawData?.status) &&
          rawData?.unsold_flag_at !== null),
      winner: rawData?.winner,
      expired: rawData?.expired,
      unsold_flag_at: rawData?.unsold_flag_at,
      auction_start_date: rawData?.auction?.auction_start_date,
      extended_end_date: rawData?.extended_end_date,
      offers: rawData?.offers,
      make_an_offer: rawData?.make_an_offer,
      withdrawn_at: rawData?.withdrawn_at,
      auctionType: auctionType,
      seller: {
        user: {
          name: rawData?.ownerUser?.name,
          profile_picture: rawData?.ownerUser?.profile_picture,
          id: rawData?.auction?.seller_id,
        },
      },
      status: rawData?.status,
    };
    return mappedAuction;
  }

  onFavoriteClick(auctionItem: any): void {
    this.toggleAddToWishlist(auctionItem?.id);
  }

  cardClicked(e: any, item: any) {
    e.stopPropagation();

    this.router.navigate(
      ['/buyer/auctions', item.aucSlug, 'horse', item?.slug],
      {
        queryParams: {
          type: 'live-horses',
        },
      }
    );
  }
  handleTimeEnded(item: any) {
    const index = this.cardAuctions.findIndex((el: any) => el?.id == item?.id);
    if (index != -1) {
      this.cardAuctions[index].can_bid = false;
      this.loadData.emit(true);
    }
  }
  loadDataEmit() {
    this.loadData.emit(true);
  }
  handleActions(e: { action: string; data: any }): void {
    const { action, data } = e;

    switch (action) {
      case 'time_ended':
        this.loadDataEmit();
        break;
      case 'load_data':
        this.loadDataEmit();
        break;
    }
  }
  toggleAddToWishlist(id: number) {
    this.toastService.clear();

    if (this.loggedIn) {
      const auction_item = this.cardAuctions.find((el) => el?.id == id);

      auction_item.wishlistClicked = true;
      let req;
      let message = '';
      if (auction_item.in_user_wishlist) {
        //remove
        req = this.auctionService.deleteFromWishlist(id);
        message = this.translate.instant('messages.success.removed_from_wishlist');
      } else {
        //add
        req = this.auctionService.addToWishlist(id);
        message = this.translate.instant('messages.success.added_to_wishlist');
      }
      req.pipe().subscribe({
        next: () => {
          auction_item.wishlistClicked = false;
          this.toastService.showSuccess(message);
          auction_item.in_user_wishlist = !auction_item.in_user_wishlist;
        },
        error: (error) => {
          auction_item.wishlistClicked = false;

          this.toastService.showError(error?.error?.Error[0]);
        },
      });
    } else {
      this.buyerService.setShowLogin(true);
    }
  }

  goToAuctions() {
    if (this.cardAuctions.length != 0 && this.displayType == 'upcoming') {
      const queryParams = { filterBy: 'upcoming' };
      this.router.navigate(['/buyer/auctions/list/all'], { queryParams });
    } else if (this.cardAuctions.length != 0 && this.displayType == 'active') {
      const queryParams = { filterBy: 'active' };
      this.router.navigate(['/buyer/auctions/list/all'], { queryParams });
    } else {
      const queryParams = { filterBy: 'previous' };
      this.router.navigate(['/buyer/auctions/list/all'], { queryParams });
    }
  }
  ngOnDestroy() {}
}
